// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"_2s2Lze87","wrapperSpacing":"_1zjoGo8c"};